"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Strapi = function Strapi(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return _react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), _react.default.createElement("path", {
    d: "M17.295 10.554a.388.388 0 01-.195-.053l-1.527-.894a.39.39 0 01-.192-.334V7.508a.387.387 0 01.193-.335l1.534-.886a.384.384 0 01.385 0l1.538.88a.388.388 0 01.195.336v1.78a.387.387 0 01-.192.335l-1.535.885a.382.382 0 01-.204.05zm-1.14-1.503l1.146.67 1.148-.663V7.725l-1.15-.659-1.15.665zM5.252 13.545a.387.387 0 01-.194-.727l1.344-.774a.387.387 0 11.386.668l-1.344.777a.384.384 0 01-.192.056zm-.292 2.341a.385.385 0 01-.19-.727l2.578-1.477a.387.387 0 11.384.67l-2.585 1.483a.384.384 0 01-.186.05zm.417 1.926a.387.387 0 01-.19-.727l3.117-1.744a.387.387 0 11.378.673l-3.11 1.744a.38.38 0 01-.195.054zM12.956 1.99L11.043.827 1.375 6.421l.019 1.599 3.657 2.11L7.44 8.764l.522-2.541a.392.392 0 01.186-.258l8.414-4.845a.391.391 0 01.387 0l6.278 3.635a.382.382 0 01.194.334l-.012 7.268a.387.387 0 01-.195.335l-8.324 4.78a.388.388 0 01-.298.037l-2.526-.714-2.368 1.378v4.197l1.385.8 9.667-5.593v-2.248l.77-.503v2.972a.385.385 0 01-.191.336l-10.052 5.815a.384.384 0 01-.387 0L9.116 22.93a.385.385 0 01-.194-.334v-4.642a.385.385 0 01.192-.333l2.702-1.572a.385.385 0 01.3-.038l2.532.716 7.995-4.587.012-6.82-5.893-3.41-8.07 4.652-.526 2.528a.387.387 0 01-.187.257l-2.727 1.569a.388.388 0 01-.386 0L.826 8.59a.387.387 0 01-.194-.33L.6 6.207a.385.385 0 01.192-.338L10.854.054a.387.387 0 01.394 0l2.471 1.502z"
  }));
};

Strapi.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Strapi.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Strapi;
exports.default = _default;